import * as React from "react";
import { SVGProps } from "react";
const SvgSubtract = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24.175 15H7.825a.735.735 0 0 0-.59.286C7.08 15.476 7 15.714 7 16s.079.524.236.714c.157.19.354.286.59.286h16.349a.733.733 0 0 0 .59-.286c.156-.19.235-.428.235-.714s-.079-.524-.236-.714a.734.734 0 0 0-.589-.286Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSubtract;
